import { render, staticRenderFns } from "./ImportClue.vue?vue&type=template&id=74ac63f6"
import script from "./ImportClue.vue?vue&type=script&lang=js"
export * from "./ImportClue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports